import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";

/**
 * CRUD Service for PropensityScoreHistory entity (F-029).
 * Provides standard CRUD operations for score history records.
 */
@Injectable({
    providedIn: 'root'
})
export class PropensityScoreHistoryService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/propensityScoreHistories')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-history';
    }
}
